import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { logout } from "src/store/Authentication/authActions";

interface LogoutProps {
  history: any;
}

const Logout = ({ history }: LogoutProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch, history]);

  return <></>;
};

export default withRouter(Logout);
